import { render, staticRenderFns } from "./bcButton.vue?vue&type=template&id=035173d5&"
import script from "./bcButton.vue?vue&type=script&lang=js&"
export * from "./bcButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports